import React, { useContext, useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../utilities/url";
import axios from "axios";
import storage from "../../../services/storage";
import { LuBookCopy } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { BiWorld } from "react-icons/bi";
import { FaTrash } from "react-icons/fa";
import {
  GrDocument,
  GrDocumentImage,
  GrDocumentSound,
  GrDocumentTxt,
  GrDocumentVideo,
} from "react-icons/gr";
import { formatFileSize } from "../../../utilities/ext-function";

const TableList = ({ cards, loading, onChangeData }) => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([
    {
      name: null,
      type: "string",
      description: null,
      enum: [],
      required: false,
    },
  ]);

  const handleCardClick = (data) => {
    const datas = {
      name: data.name.replace(/\s+/g, ""),
      description: data.description,
      parameters: rows,
      active: "Y",
      exec_type: "api",
      endpoint: data.url_path,
      method: "GET",
      headers: null,
      body_type: "form-data",
      body: null,
      credentials: null,
      response_filter: null,
      response_prompt: null,
      response_media_type: null,
      response_media_url: null,
    };
    // console.log(datas);
    onChangeData(datas);
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-custome">
        <thead className="text-light">
          <tr className="fs-15">
            <th className="p-2">File Name</th>
            <th className="p-2">Media ID</th>
            <th className="p-2">Description</th>
            <th className="p-2">Media Type</th>
          </tr>
        </thead>
        <tbody>
          {!loading ? (
            cards.length > 0 ? (
              <>
                {cards.map((card, index) => (
                  <tr key={index}>
                    <td className="align-middle p-2">
                      <div className="d-flex align-items-center">
                        {card.media_type === "image" && (
                          <GrDocumentImage size={20} className="me-3" />
                        )}
                        {card.media_type === "document" && (
                          <GrDocument size={20} className="me-3" />
                        )}
                        {card.media_type === "text" && (
                          <GrDocumentTxt size={20} className="me-3" />
                        )}
                        {card.media_type === "audio" && (
                          <GrDocumentSound size={20} className="me-3" />
                        )}
                        {card.media_type === "video" && (
                          <GrDocumentVideo size={20} className="me-3" />
                        )}
                        <a
                          className="link"
                          onClick={() => handleCardClick(card)}
                        >
                          {card.name}
                        </a>
                      </div>
                    </td>
                    <td className="align-middle p-2">{card.fileid}</td>
                    <td className="align-middle p-2">
                      {card.description ? card.description : "-"}
                    </td>
                    <td className="align-middle p-2">
                      {card.media_type}/{card.extension}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colspan="8">
                  <div className="text-center fs-14 my-5">No Data</div>
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td colspan="8">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                  style={{ height: "315px" }}
                >
                  <div class="loading-backdrop-2">
                    <div class="spinner-border"></div>
                  </div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableList;
